"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselItem = void 0;
const react_1 = __importDefault(require("react"));
const className_1 = require("../../../utils/className");
exports.CarouselItem = ({ id, className = 'coBranded-card', dark = false, text, url, }) => {
    return (react_1.default.createElement("a", { href: url, className: "fake-card fake-focus" },
        react_1.default.createElement("div", { className: className_1.mapToCssModules([className, dark ? 'dark' : '']), id: id },
            react_1.default.createElement("div", { className: "coBranded-card-link" },
                react_1.default.createElement("span", { className: "coBranded-card-clamp" }, text)))));
};
//# sourceMappingURL=index.js.map